import { TabButton } from './TabButton';

export type Props = {
    tabLabels: string[];
    activeTabIndex: number;
    onSelect(tabIndex: number): void;
};

export const TabButtonStrip = ({ tabLabels, activeTabIndex, onSelect }: Props) => {
    return (
        <div className="tab-button-strip">
            { tabLabels.map((label, i) =>
                <TabButton
                    key={ label }
                    tabIndex={ i }
                    label={ label }
                    active={ i === activeTabIndex }
                    onSelect={ () => onSelect(i) }
                />
            ) }
        </div>
    );
};
